'use client';

import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import CalculatorHero from './components/CalculatorHero';
import CalculatorForm from './components/CalculatorForm';
import { useLanguage } from '@/contexts/LanguageContext';

export default function Calculator() {
  const { language } = useLanguage();

  return (
    <>
      <Header />
      <main className="min-h-screen">
        <CalculatorHero language={language} />
        <CalculatorForm language={language} />
      </main>
      <Footer />
    </>
  );
}